// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-421218d6]{align-items:center;background-color:#495057;border-radius:4px;display:flex}@media(max-width:985px){.item[data-v-421218d6]{gap:2px;padding:8px 12px}}@media(min-width:986px){.item[data-v-421218d6]{gap:4px;padding:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
